export function isUndefined(x) {
  return x === null || x === undefined;
}

export function isUndefinedOrEmpty(x) {
  return x === null || x === undefined || x === '';
}

export function omit(obj, ...propNames) {
  const result = { ...obj };
  propNames.forEach((p) => delete result[p]);
  return result;
}

export function pick(obj, ...propNames) {
  if (isUndefined(obj)) return {};
  return Object.keys(obj).filter((k) => propNames.includes(k)).reduce((res, k) => {
    res[k] = obj[k];
    return res;
  }, {});
}

export function any(obj) {
  if (Array.isArray(obj)) {
    return obj.length === 0 ? undefined : obj[0];
  }
  if (typeof obj === 'object') {
    const keys = Object.keys(obj);
    return keys.length === 0 ? undefined : obj[keys[0]];
  }
  return obj;
}

export function last(arr) {
  if (arr && arr.length > 0) return arr[arr.length - 1];
  return undefined;
}

export function isObject(object) {
  return object != null && typeof object === 'object';
}

export function isDeepEqual(obj1, obj2) {
  if (isObject(obj1) && isObject(obj2)) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1) {
      if (!isDeepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }
  return obj1 === obj2;
}

export function uuid(template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx') {
  let d = new Date().getTime();// Timestamp
  // Time in microseconds since page-load or 0 if unsupported
  let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
  return template.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16;// random number between 0 and 16
    if (d > 0) { // Use timestamp until depleted
      // eslint-disable-next-line no-bitwise
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else { // Use microseconds since page-load if supported
      // eslint-disable-next-line no-bitwise
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    // eslint-disable-next-line no-mixed-operators, no-bitwise
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

/**
 * Crea una promise risolta dalla chiamata delle funzioni resolve o reject parametri di func,
 * o dalla scadenza del timeout (ritorna una Error con testo `timeout expired`)
 * @param {func} func funzione con 2 parametri resolve e reject per risolvere o regettare il task
 * @param {number} timeout timeout in mills
 * @returns {Promise} promise
 */
export function withTimeout(func, timeout) {
  return new Promise((resolve, reject) => {
    let timeoutId = setTimeout(() => {
      timeoutId = undefined;
      reject(new Error('timeout expired'));
    }, timeout);

    func(
      (value) => {
        if (timeoutId) {
          clearTimeout(timeoutId);
          resolve(value);
        } else {
          // ignoro il timeout è già scattato!
        }
      },
      (error) => {
        if (timeoutId) {
          clearTimeout(timeoutId);
          reject(error);
        } else {
          // ignoro il timeout è già scattato!
        }
      },
    );
  });
}
